import { usd } from "./util";

const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "set", "oct", "nov", "dic"];
const mesLargo = (ym) => `${MESES[Number(ym.slice(5, 7)) - 1]} ${ym.slice(0, 4)}`;
const PILL = (e) => (!e ? null : e.startsWith("Falta") || e.includes("con vencidos") ? ["rgba(224,96,62,.18)", "#F08A6C"] : e.startsWith("Cubierto") ? ["rgba(46,154,94,.2)", "#7DBE8C"] : ["rgba(210,162,58,.2)", "#E6C46A"]);

const exige = (m) => (!m ? ["—", ""] : m.revisar ? ["Por rubro", ""] : m.modo === "fijo" ? [usd(m.exigido), "monto fijo"] : m.modo?.startsWith("encima") ? [usd(m.exigido), `por encima de ${usd(m.umbral)}`] : [usd(m.exigido), "toda la deuda"]);

export const Terceros = ({ d }) => {
  const c = d.condiciones;
  const t = c?.terceros, m = c?.condicion?.terceros, pag = c?.pagares || [];
  if (!c || (!m && !(t?.cobertura > 0))) return null;
  const hoy = d.fecha_corte || "";
  const venc = pag.filter((p) => (p.vencimiento || "9999") < hoy), vig = pag.filter((p) => (p.vencimiento || "9999") >= hoy);
  const sum = (a) => a.reduce((s, p) => s + (p.valor || 0), 0);
  const tv = sum(venc), tn = sum(vig), tot = tv + tn;
  const meses = Object.entries(vig.reduce((o, p) => { const k = (p.vencimiento || "").slice(0, 7); o[k] = (o[k] || 0) + (p.valor || 0); return o; }, {})).sort();
  const chips = meses.slice(0, 3), resto = meses.slice(3);
  const [ex, sub] = exige(m), pill = PILL(t?.estado);
  const col = { fontSize: 11, color: "#8E9B8A", letterSpacing: ".06em", fontWeight: 700 };
  const chip = (bg, fg) => ({ background: bg, color: fg, borderRadius: 9999, padding: "4px 10px", fontSize: 11, fontWeight: 700 });
  return (
    <section className="rs-panel der rg-sec rg-ter" style={{ border: "1px solid #3A4036", borderRadius: 22, padding: "16px 18px" }} data-testid="resumen-terceros-card">
      <div className="flex items-center justify-between" style={{ marginBottom: 10 }}>
        <h3 style={{ margin: 0 }}>Pagarés de terceros</h3>
        {pill && <span style={chip(pill[0], pill[1])} data-testid="resumen-terceros-estado">{t.estado}</span>}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div><div style={col}>TIENE</div><b data-testid="resumen-terceros-tiene">{usd(tot)}</b><p className="text-xs" style={{ color: "#A9B8A5" }}>{pag.length} pagaré{pag.length === 1 ? "" : "s"}</p></div>
        <div><div style={col}>EXIGE EL ACTA</div><b data-testid="resumen-terceros-exige">{ex}</b><p className="text-xs" style={{ color: "#A9B8A5" }}>{sub}</p></div>
        <div><div style={col}>PENDIENTE</div><b style={{ color: t?.falta > 0 ? "#F08A6C" : undefined }} data-testid="resumen-terceros-pendiente">{m?.revisar ? "—" : usd(t?.falta ?? 0)}</b></div>
      </div>
      <div style={{ display: "flex", height: 10, borderRadius: 9999, overflow: "hidden", background: "#28332B", marginTop: 12 }}>
        {tot > 0 && <span style={{ width: `${(tn / tot) * 100}%`, background: "#2E9A5E" }} />}
        {tot > 0 && <span style={{ width: `${(tv / tot) * 100}%`, background: "#E0603E" }} />}
      </div>
      <div className="flex justify-between text-xs" style={{ marginTop: 6 }}>
        <span style={{ color: "#A9B8A5" }}>No vencido <b style={{ color: "#F3F7F2" }} data-testid="resumen-terceros-no-vencido">{usd(tn)}</b></span>
        <span style={{ color: "#F08A6C" }}>Vencido <b data-testid="resumen-terceros-vencido">{usd(tv)}</b></span>
      </div>
      <div className="flex gap-2 rg-ter-chips" style={{ marginTop: 10 }} data-testid="resumen-terceros-chips">
        {tv > 0 && <span style={chip("rgba(224,96,62,.18)", "#F08A6C")}>Vencidos · {usd(tv)}</span>}
        {chips.map(([k, v]) => <span key={k} style={chip("#33402F", "#F3F7F2")}>{mesLargo(k)} · {usd(v)}</span>)}
        {resto.length > 0 && <span style={chip("#33402F", "#A9B8A5")}>+{resto.length}</span>}
      </div>
    </section>
  );
};
